import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from '@/App.tsx';
import { initStaleAppReload } from './stale-app-reload';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (!sentryDsn) {
  throw new Error('Missing Sentry environment variables');
}

Sentry.init({
  dsn: sentryDsn,
  environment: import.meta.env.MODE,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

initStaleAppReload();

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
